import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.cat-container {
    margin-bottom: calc(8px * 2);
}
.category-label {
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    font-size: 12px;
    color: #4c5a6a;
    text-transform: uppercase;
}
.category {
    font-size: 18px;
  font-family: 'Nimbus Sans Light', sans-serif;
  font-weight: normal;
}
.disclaimer {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
    margin-top: calc(8px * 2);
}
.morningstar-footer-text {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
    line-height: 1.2;
    padding-top: calc(24px / 2);
    padding-bottom: calc(calc(24px / 2) / 2);
    letter-spacing: 0.5px;
}
`;

export default styles;